module.exports = __webpack_public_path__ + "img/product-preview-15.f3317d1.png";